import { useState } from "react";
import { BadgePercent, KeyRound, Gamepad2, LayoutDashboard, LogOut, ReceiptText, Settings, ShieldCheck, FileDown, Users } from "lucide-react";
import { Logo } from "../../components/laxmi/Chrome";
import AdminDashboard from "./AdminDashboard";
import AdminTransactions from "./AdminTransactions";
import AdminUsers from "./AdminUsers";
import AdminGame from "./AdminGame";
import AdminBonus from "./AdminBonus";
import AdminReports from "./AdminReports";
import AdminSettings from "./AdminSettings";
import AdminAdmins from "./AdminAdmins";
import AdminSecurity from "./AdminSecurity";

const TABS = [
  ["dashboard", "Dashboard", LayoutDashboard, null, AdminDashboard], ["transactions", "Deposits & Withdrawals", ReceiptText, "transactions", AdminTransactions],
  ["users", "Users", Users, "users", AdminUsers], ["game", "Game periods", Gamepad2, "games", AdminGame], ["bonus", "Bonus", BadgePercent, "bonus", AdminBonus],
  ["reports", "Reports", FileDown, "reports", AdminReports], ["settings", "Website settings", Settings, "settings", AdminSettings], ["admins", "Admins", ShieldCheck, "admins", AdminAdmins], ["security", "Change password", KeyRound, null, AdminSecurity],
];

export default function AdminApp({ admin, onLogout }) {
  const perms = admin.permissions || [];
  const tabs = TABS.filter(t => !t[3] || perms.includes("all") || perms.includes(t[3]));
  const [tab, setTab] = useState("dashboard");
  const Current = (tabs.find(t => t[0] === tab) || tabs[0])[4];
  return (
    <div className="admin-shell" data-testid="admin-panel">
      <div className="admin-head"><Logo /><button onClick={onLogout} data-testid="admin-logout-button"><LogOut /></button></div>
      <div className="admin-title"><ShieldCheck /><div><small>PRIVATE ADMIN · {admin.phone}</small><h1>Operations center</h1></div></div>
      <nav className="admin-tabs">{tabs.map(([id, label, Icon]) => <button key={id} className={tab === id ? "on" : ""} onClick={() => setTab(id)} data-testid={`admin-tab-${id}`}><Icon />{label}</button>)}</nav>
      <Current setTab={setTab} admin={admin} />
    </div>
  );
}
